// extracted by mini-css-extract-plugin
export var currencyInput = "_o7-1";
export var currencySymbol = "_o7-0";